interface IAddress {
    street: string;
    houseNumber: string;
    zip: string;
    city: string;
    country: string;
}

export const areAddressesSame = (address1: IAddress, address2: IAddress) => {
    for (const key of Object.keys(address1)) {
        if (address1[key] != address2[key]) {
            return false;
        }
    }

    return true;
};



// WEBPACK FOOTER //
// ./src/helpers/areAddressesSame.ts